import { FirebaseActionTypes, FirebaseActions } from '@web_opxp/features';

// page open action
export const startPageAction: () => FirebaseActionTypes.IAnalyticsEventAction = () => {
  return FirebaseActions.analyticsEventAction({
    eventName: 'o_subscribe_page',
  });
};

export const trackPageOnTaboola = () => FirebaseActions.taboolaSubscribeEventAction();
export const trackPageOnOutbrain = () => FirebaseActions.outbrainSubscribeEventAction();

// open checkout action
export const redirectToCheckoutAction: (productName: string) => FirebaseActionTypes.IAnalyticsEventAction = (
  productName
) => {
  return FirebaseActions.analyticsEventAction({
    eventName: 'o_checkout',
    parameters: [
      {
        key: 'Package',
        value: productName,
      },
    ],
  });
};
